import { KnowledgeSite } from '../../core/client/ClientProvider'
import { axiosClient } from '../axiosClient'

export const knowledgeFunctions = {
  /**
   * Fetch the toggleable knowledge sources the current user may see.
   * See `GET /api/knowledge/visible-sources`. Per-user: the gate is applied
   * server-side, so restricted source names never reach an ungated user.
   */
  async fetchVisibleSources(): Promise<KnowledgeSite[]> {
    return axiosClient.get('/api/knowledge/visible-sources')
  },
}
